export const EntryType = Object.freeze({
  FOLDER: 'folder',
  FILE: 'file',
});
